import { t } from "../../i18n/t";
import type { PracticeRole } from "../../api/types";

/** `PracticeRole` has exactly two values, so this is a plain function rather than `tDynamic` — `tests/i18n.test.ts`
 * only exempts the documented dynamic families (`state.`, `job.`, …) from its "every key is referenced" check,
 * and `practice.role.` is not one of them; a template-literal `t(\`practice.role.${role}\`)` call would leave
 * both keys looking unreferenced. */
export function roleLabel(role: PracticeRole): string {
  return role === "OWNER" ? t("practice.role.OWNER") : t("practice.role.STAFF");
}
